import { GENERATED_THEME, ThemeConfig } from "./theme.generated";

const origin = window.location.origin;
export const environment = {
    apiUrl: 'http://localhost:9595',
    production: false,
    homeButtonLink: '/marktplatz',
    specialCharacterRegex: /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g,
    defaultPictureProducts: '/assets/svg-icons/standardIcon.svg',
    defaultPicturePTGs: '/assets/img/defaultPtg.png',
    defaultPictureOrganisationProducts: '/assets/svg-icons/products.svg',
    defaultPicuterOrganisationCertifications: '/assets/svg-icons/certification_ptg.svg',
    defaultPictureOrganisationPTGs: '/assets/svg-icons/ptgs.svg',
    defaultPictureProfile: '/assets/svg-icons/profile.svg',
    certificationAttributeIcon: '/assets/svg-icons/certification_attribute.svg',
    certificationPtgIcon: '/assets/svg-icons/certification.svg',
    certificationToolchain: '/assets/svg-icons/certification_toolchain.svg',
    certificationDefaultImage: '/assets/img/misc/certification_attribute_gold.png',
    certificationAttributeMandatory: '/assets/img/SWARM-Logo.png',
    partnerCert: '/assets/img/partnershipCert.svg',
    theme: GENERATED_THEME satisfies ThemeConfig,
    anonymous: [
        'swarm-frontend',
        'swarm-frontend-dev',
        'swarm-frontend-staging',
        'swarm-frontend-prod',
        'swarm-frontend-prod2',
        'swarm-frontend-live'
    ],
    oauthLoginUri: '/sso/oauth2/authorize?client_id=swarm-frontend&response_type=code&scope=read',
    oauthRegisterApp: '/sso/oauth2/client/registration',
    GA_TRACKING_ID: '',
    database_host: "pre-prod.bimswarm.online",
    this: {
        ourDomain: "localhost"
    },
    server: {
        endpoints: {
            baseUrl: "proxy/api/v0/stripeservice",
            userService: {
                users: {
                    activateAutoLogin: "userservice/users/activate/auto/login"
                },
            },
            stripe: {
                registerSubscriptionInDB: "/stripeOrganisations/subscriptions/register",
                updateStripeUserNewPayment: "/stripeOrganisations/updateOrgData/fromStripe",
                addSubscription: "/stripeOrganisations/subscriptions",
                subscriptionData: "/stripeOrganisations/subscriptions",
                subscriptionsSize: "/stripeOrganisations/subscriptions/size",
                updateSubscription: "/stripeOrganisations/subscriptions/update",
                cancelSubscription: "/stripeOrganisations/subscriptions/cancel",
                resumeSubscription: "/stripeOrganisations/subscriptions/resume",
                subscriptionDataSize: "/stripeOrganisations/subscriptions/size",
                addPaymentMethod: "/stripeOrganisations/paymentMethods",
                paymentData: "/stripeOrganisations/paymentMethods",
                checkPaymentMethodToDelete: "/stripeOrganisations/paymentMethods/deletionCheck",
                deletePaymentMethod: "/stripeOrganisations/paymentMethods",
                billingData: "/stripeOrganisations/bills",
                billingDataSize: "/stripeOrganisations/bills/size",
                getListings: "/listings",
                getCurrentUsage: "/listings/currentUsage",
                isListingAvailable: "/listings/availability",
                addProductToListing: "/listings/add/product",
                getProductsFromListing: "/listings/products",
                removeProductFromListing: "/listings/remove/product",
                getOrgIdBySubscriptionId: "/listings/organisation/",
                prioritizeProduct: '/listings/prioritize',
                isProductPrioritized: '/listings/prioritized',
                validateCoupon: '/stripe/listCoupons',
                couponDiscount: '/stripe/couponDiscount'
            },
            did_manager: {
                baseUrl: "proxy/api/v0/cx-features/did-manager",
                did: "proxy/api/v0/cx-features/did-manager/did",
                didWeb: "proxy/api/v0/cx-features/did-manager/did/web",
                exists: "proxy/api/v0/cx-features/did-manager/did/exists",
                institution: "proxy/api/v0/cx-features/did-manager/did/institution",
                doc: "proxy/api/v0/cx-features/did-manager/did/doc",
                fetchCert: "proxy/api/v0/cx-features/did-manager/did/doc/fetch/cert",
                fetchSsl: "proxy/api/v0/cx-features/did-manager/did/doc/fetch/ssl",
                keystore: "proxy/api/v0/cx-features/did-manager/keystore/did",
                keys: "proxy/api/v0/cx-features/did-manager/keystore/did/keys"
            },
            wallet: {
                certificates: "proxy/api/v0/cx-features/issuance/certificates",
                show: "proxy/api/v0/cx-features/wallet/bimswarm/certificates/show"
            }
        },
        stripe: {
            checkoutUrl: {
                successUrl: `${origin}/customer-area/subscription/-1`,
                cancelUrl: `${origin}/customer-area/subscription/-2`
            },
            addPaymentMethodUrl: {
                successUrl: `${origin}/`,
                cancelUrl: `${origin}/organisations/`
            }
        }
    }
};



// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
